import { zodResolver } from '@hookform/resolvers/zod';
import type { PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import { BlockedRecordStaffSchema, type BlockedRecordStaffFormInput } from './schema';

interface BlockedRecordStaffFormProviderProps extends PropsWithChildren {
  initialValues?: BlockedRecordStaffFormInput;
}

export default function BlockedRecordStaffFormProvider(
  props: Readonly<BlockedRecordStaffFormProviderProps>,
) {
  const { children, initialValues } = props;

  const formContext = useForm<BlockedRecordStaffFormInput>({
    resolver: zodResolver(BlockedRecordStaffSchema),
    defaultValues: initialValues,
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
